import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router';
import { ApiError } from '@/api';
import { verifyInstitutionalEmail } from '@/platform/api';
import { AuthHeader } from './AuthHeader';

type State =
  { status: 'loading' } | { status: 'done'; email: string } | { status: 'error'; message: string };

/** Opened from the e-mailed link: /verificar-email?token=... Works on any device, signed in or not. */
export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<State>(
    token
      ? { status: 'loading' }
      : { status: 'error', message: 'Link incompleto. Abra de novo o link do e-mail.' },
  );

  useEffect(() => {
    if (!token) return;
    let active = true;
    verifyInstitutionalEmail(token).then(
      ({ email }) => active && setState({ status: 'done', email }),
      (err: unknown) =>
        active &&
        setState({
          status: 'error',
          message:
            err instanceof ApiError
              ? err.message
              : 'Não foi possível confirmar agora. Tente de novo.',
        }),
    );
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <>
      <AuthHeader title="Confirmação de e-mail" />
      {state.status === 'loading' && (
        <Stack direction="row" spacing={2} sx={{ alignItems: 'center', py: 2 }}>
          <CircularProgress size={24} />
          <Typography>Confirmando seu e-mail…</Typography>
        </Stack>
      )}
      {state.status === 'done' && (
        <Alert severity="success" sx={{ mb: 3 }}>
          <AlertTitle>E-mail confirmado!</AlertTitle>
          {state.email} agora está vinculado à sua conta. Pode fechar esta aba ou continuar por
          aqui.
        </Alert>
      )}
      {state.status === 'error' && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {state.message}
        </Alert>
      )}
      {state.status !== 'loading' && (
        <Button component={RouterLink} to="/" variant="contained" size="large" fullWidth>
          Continuar para o Lousa
        </Button>
      )}
    </>
  );
}
